import { useEffect } from "react";
import { useAddItemSlide } from "@/components/Item/ItemSlides";

/**
 * Écoute les messages postMessage HUBIL_OPEN_PDF
 * envoyés par l'iframe HUBIL (proxy hubidlp)
 * et ouvre le PDF en slide dans NodeAuto.
 */
export const useHubilPdfListener = (): void => {
    const { addIframeSlide } = useAddItemSlide();
    useEffect(() => {
        const handler = (event: MessageEvent) => {
            if (!event.data || event.data.type !== "HUBIL_OPEN_PDF") return;
            const url = event.data.url as string;
            if (!url) return;
            addIframeSlide(url, false);
        };
        window.addEventListener("message", handler);
        return () => window.removeEventListener("message", handler);
    }, [addIframeSlide]);
};
